module.exports = __webpack_public_path__ + "img/about-icon4.5beb64da.png";